<template>
  <v-app :dark="darkMode" id="inspire" class="background">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "AuthLayout",
  computed: {
    ...mapGetters("app", {
      darkMode: "darkMode"
    }),
  }
};
</script>



